import * as React from 'react';

import { ark } from '@ark-ui/react';

import { cn } from '../../lib/utils';

export const Breadcrumb = React.forwardRef<
	HTMLElement,
	React.ComponentPropsWithoutRef<'nav'> & {
		separator?: React.ReactNode;
	}
>(({ ...props }, ref) => (
	<nav ref={ref} aria-label="breadcrumb" data-slot="breadcrumb" {...props} />
));

Breadcrumb.displayName = 'Breadcrumb';

export const BreadcrumbList = React.forwardRef<
	HTMLOListElement,
	React.ComponentPropsWithoutRef<'ol'>
>(({ className, ...props }, ref) => (
	<ol
		ref={ref}
		data-slot="breadcrumb-list"
		className={cn('pt-breadcrumb-list', className)}
		{...props}
	/>
));

BreadcrumbList.displayName = 'BreadcrumbList';

export const BreadcrumbItem = React.forwardRef<HTMLLIElement, React.ComponentPropsWithoutRef<'li'>>(
	({ className, ...props }, ref) => (
		<li
			ref={ref}
			data-slot="breadcrumb-item"
			className={cn('pt-breadcrumb-item', className)}
			{...props}
		/>
	)
);

BreadcrumbItem.displayName = 'BreadcrumbItem';

export const BreadcrumbLink = React.forwardRef<
	HTMLAnchorElement,
	React.ComponentPropsWithoutRef<typeof ark.a>
>(({ className, ...props }, ref) => {
	return (
		<ark.a
			data-slot="breadcrumb-link"
			className={cn('pt-breadcrumb-link', className)}
			{...props}
			ref={ref}
		/>
	);
});

BreadcrumbLink.displayName = 'BreadcrumbLink';

export const BreadcrumbPage = React.forwardRef<
	HTMLAnchorElement,
	React.ComponentPropsWithoutRef<typeof ark.span>
>(({ className, ...props }, ref) => (
	<ark.span
		ref={ref}
		role="link"
		aria-disabled="true"
		aria-current="page"
		data-slot="breadcrumb-page"
		className={cn('pt-breadcrumb-page', className)}
		{...props}
	/>
));

BreadcrumbPage.displayName = 'BreadcrumbPage';

export const BreadcrumbSeparator = ({ ...props }: React.ComponentProps<'li'>) => (
	<li data-slot="breadcrumb-separator" {...props} />
);

BreadcrumbSeparator.displayName = 'BreadcrumbSeparator';

export const BreadcrumbEllipsis = ({ className, ...props }: React.ComponentProps<'span'>) => (
	<span
		role="presentation"
		aria-hidden="true"
		data-slot="breadcrumb-ellipsis"
		className={cn('pt-breadcrumb-ellipsis', className)}
		{...props}
	>
		<span className="sr-only">More</span>
	</span>
);

BreadcrumbEllipsis.displayName = 'BreadcrumbEllipsis';
